import endpoint from "../../config/endpoints";

export const regionJson = {
  showSaveNextBtn: true,
  formPath: "/region-form",
  apiBaseURL: endpoint.region,
  changeExcel: endpoint.exportData,
  screenTitle: "Region",
  showAddButton: true,
  showPdfDownload: true,
  pdfFileName: "Region",
  showExcelDownload: true,
  excelFileName: "Region",
  formPathView: "/region-view",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Name",
      columnKeyName: "name",
      isChecked: true,
    },
    {
      columnDisplayName: "Country",
      columnKeyName: "countryName",
      isChecked: true,
    },
    {
      columnDisplayName: "State Count",
      columnKeyName: "stateCount",
      isChecked: true,
    },
    {
      columnDisplayName: "Zone Count",
      columnKeyName: "zoneCount",
      isChecked: true,
    },
    {
      columnDisplayName: "District Count",
      columnKeyName: "districtCount",
      isChecked: true,
    },
    {
      columnDisplayName: "Taluka Count",
      columnKeyName: "talukaCount",
      isChecked: true,
    },
    {
      columnDisplayName: "Area Count",
      columnKeyName: "areaCount",
      isChecked: true,
    },
    {
      columnDisplayName: "Beat Count",
      columnKeyName: "beatCount",
      isChecked: true,
    },
    {
      columnDisplayName: "Outlet Count",
      columnKeyName: "outletCount",
      isChecked: true,
    },
    {
      columnDisplayName: "Sort Order Number",
      columnKeyName: "sortOrder",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "Country",
      controlType: "autocomplete",
      placeHolder: "Select Country",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "countryDetail",
      dataKey: "country",
      isRootLevelKey: false,
      isMandatory: true,
    },
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      autoFocus: true,
      dataKey: "name",
      isMandatory: true,
      uniqueValidation: true,
    },
    {
      label: "Short Name",
      controlType: "textfield",
      placeHolder: "Short Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "shortName",
      isMandatory: true,
    },
    {
      label: "Sort Order No",
      controlType: "textfield",
      placeHolder: "Sort Order No",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "sortOrder",
      isMandatory: true,
    },
  ],

  fieldMetaForSalesRegionAssignation: [
    {
      label: "Stock Holder Type",
      controlType: "multiSelect",
      placeHolder: "Select Stock Holder Type",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockHolderType",
      getListId: "stockHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Stock Holder Name",
      controlType: "multiSelect",
      placeHolder: "Select Stock Holder Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stockHolderNameDetail",
      dataKey: "stockHolderName",
      getListId: "stockHolderName",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
};
